import { useMaterialAPI } from "../../../api/material/useMaterialAPI";
import { materialActions } from "./MaterialReducer";

export const useMaterial = () => {
    const api = useMaterialAPI();
  
    const request = {
        get: (params) => {
          return async (dispatch) => {
            try {
              const response = await api.material.get(params);
              dispatch(materialActions.funGetMaterial(response));
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          }
        },
        post: async (data) => {
          return await api.material.post(data);
        },
        put: async (data) => {
          return await api.material.put(data);
        },
        delete: async (params) => {
          return await api.material.delete(params);
        }
    };
    return { request };
  };